export default "__VITE_ASSET__BwSn8FPp__"